export const MENU_FEATURED_ITEM_CHOSEN = 'MENU_FEATURED_ITEM_CHOSEN';

export function setMenuFeaturedItemChosen(menuItemId) {
  return (dispatch) => {
    dispatch({ menuItemId, type: MENU_FEATURED_ITEM_CHOSEN });
  };
}
